import React from "react";
import { connect } from "react-redux";

import { authentication, logOut } from "../app-database";

import { callService, goTo } from "../tools";
import Notificaciones from "../notificaciones/notificaciones.cmpt";
import { servicios } from "../properties";
import { messageService } from "../centro-atencion-gnp/centro-atencion.service";
const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.olvide.paso,
		nombre: state.global.nombre,
		lastlogin: state.global.lastlogin,
		cliente: state.global.clienteUnico,
		ntfBullet: state.notificaciones.bullet,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		siguientePaso: (iPaso) => {
			dispatch({ "type": "OLVIDE_PASO_SIGUIENTE", paso: iPaso});
		},
		cerrarSesion: () => {
			dispatch({ "type": "USER_LOGOUT" });
		},
		addEvento: (evento) => {
			dispatch({ "type": "NOTIFICACIONES_SET_EVENT", "evento": evento});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Encabezado extends React.Component {

	state = {
		ntfIcon: [
			require("../img/notificacion.svg"),
			require("../img/notificacion_active.svg"),
		],
		mobileClass: "hide",
		activeHead: "active-head",
		menuTitle: "",
		arrow: [
			require("../img/flecha-abajo-blanco.svg"),
			require("../img/flecha-arriba-blanco.svg")
		],
		arrowIndex: 0,
		polizasClass: "",
		directorioClass: "",
		tramitesClass: "",
		perfilClass: "",
	}

	toggleClass = () => {
		var arrowIndex;
		if (this.state.arrowIndex == 1) {
			arrowIndex = 0;
		} else if (this.state.arrowIndex == 0) {
			arrowIndex = 1;
		}

		this.setState({
			mobileClass: this.state.mobileClass == "hide" ? "" : "hide",
			arrowIndex: arrowIndex,
		});
	}
	optionGo = (sRuta) => {

		this.setState({
			menuTitle: event.target.innerHTML,
		});
		this.toggleClass();
		this.pickClass(sRuta);
	}

	pickClass = (sRuta) => {

		var location = window.location.hash.split("/")[1];
		var click = false;
		if (sRuta) {
			location = sRuta;
			click = true;
		}
		var temporal = {
			polizasClass: "",
			directorioClass: "",
			tramitesClass: "",
			seguimientoClass: "",
			perfilClass: "",
			menuTitle: "Mis pólizas"
		};



		switch (location) {
		case "home":
			temporal.menuTitle = "Mis pólizas";
			temporal.polizasClass = "active";
			temporal.seguimientoClass = "";
			if (click){
				this.props.tagManager({ "type": "EVENT_HOME_MENU-MISPOLIZAS", "dispositivo": this.props.dispositivo });
			}
			break;
		case "directorio":
			temporal.menuTitle = "Directorio";
			temporal.directorioClass = "active";
			temporal.seguimientoClass = "";
			break;
		case "mis-tramites":
			temporal.menuTitle = "Mis trámites";
			temporal.tramitesClass = "active";
			temporal.seguimientoClass = "";
			break;
		case "seguimiento-siniestros":
			temporal.menuTitle = "Mis trámites";
			temporal.seguimientoClass = "active";
			break;
		case "mi-perfil":
			temporal.menuTitle = "Mi perfil";
			temporal.perfilClass = "active";
			temporal.seguimientoClass = "";
			break;
		default:
		}
		this.setState(temporal);

		if (sRuta) {
			goTo(sRuta);
		}
	}

	componentWillMount = () => {
		this.pickClass();
		localStorage.setItem("esCliente","true");
		localStorage.setItem("esMoral", "0");
		this.esMoral();
	}


	siguiente = () => {
		this.props.siguientePaso(this.props.paso + 1);
	}

	verNotificaciones = () => {
		this.props.addEvento("Abrir");
		this.notificaciones.abrir();
	}

	cerrarSesion = () => {
		logOut();
		// Se limpia Item en el local storage para no mostrar.
		if(localStorage.getItem("esCliente")){
			localStorage.removeItem("esCliente");
			localStorage.removeItem("planesCliente");
			localStorage.removeItem("esMoral");
		}
	}

	ir = (sRuta) => {
		goTo(sRuta);
	}

	close = () => {
	}

	irRutaConIframe = (sRuta) => {
		goTo(sRuta);
		console.log(sRuta);
		messageService.sendMessage(servicios.iframeGNPURL.centroAtencionGNP);
	}


	esMoral = () => {
		let llamaServicio = new callService({ service: "utilerias.clientesMorales", secure: false, data: { "cveClienteUnico": this.props.cliente, "cifrado": false } }).execute();
		llamaServicio.then((respuesta) => {
			this.setState({loading: true});
			console.log("Respuesta", respuesta);
			if(respuesta.moral){
				console.log("Moral:" + respuesta.moral);
				localStorage.setItem("esMoral","2");
				this.setState({loading: false});
			}
		}).catch((error) => {
			if(error.status == 204){
				console.log("Moral:" + error.status);
				localStorage.setItem("esMoral","1");
			}
			console.log("Error", error);
			this.setState({loading: false});
		});

	}

	render() {
		if (this.state.loading) return null;
		return (
			<div>
				<div className="main-header clearfix mt-25 hide-mobile">
					<div className="logo-header">
						<a onClick={this.pickClass.bind(this, "home")}><img src={ require("../img/logo-gnp.svg") } /></a>
					</div>
					<div className="bienvenida-wrap">
						<p><b>Hola </b><span className="orange-bold-text">{ this.props.nombre }</span></p>
						<p>Número de Cliente: <span className="blue-bold-text">{ this.props.cliente }</span></p>
						<p>Última sesión: <span>{ this.props.lastlogin }</span></p>
					</div>
					<div className="perfil-options mt-20">
						<ul>
							<li>
								<a onClick={this.irRutaConIframe.bind(this, "centro-atencion-gnp")} >
									<label className="centro-atencion-gnp-text">Centro de Atención GNP Virtual</label>
									<img className="centro-atencion-gnp-icon" src={require("../img/centro-atencion-gnp.svg")} title="Acceso Compartido" />
								</a>
							</li>
						    <li><a onClick={ this.ir.bind(this, "acceso-familiar") }>
								<img className="acceso-familiar-icon" src={ require("../img/acceso-familiar-icon.svg") } title="Acceso Compartido" />
							</a></li>
							<li>
	                            <a onClick={this.verNotificaciones.bind(this)}>
	                                <img src={ require("../img/notificacion.svg") } style={{ "height": "30px", "width": "30px" }} title="Notificaciones" />
	                                { this.props.ntfBullet > 0 &&
	                                	<sup style={{"fontSize":"10px"}}>{ this.props.ntfBullet }</sup>
	                                }
	                            </a>
	                        </li>
							<li>
								<a onClick={ this.ir.bind(this, "beneficios") }>
									<img className="beneficios-soy-cliente-icon" src={ require("../img/beneficios-soy-cliente.svg") } title="Beneficios" />
								</a>
							</li>
							<li>
	                            <a onClick={this.cerrarSesion.bind(this)}>
									<img style={{ "height": "30px", "width": "25px" }}
									src={ require("../img/log-out.svg" )} title="Cerrar Sesión" />
								</a>
	                        </li>
						</ul>
					</div>
				</div>
				<div className="blue-wrap hide-mobile">
					<div className="container">
						<ul className="blue-menu clearfix">
							<li><a onClick={this.pickClass.bind(this, "home")} className={this.state.polizasClass}>Mis pólizas</a></li>
							<li><a onClick={this.pickClass.bind(this, "directorio")} className={this.state.directorioClass} id="directorioMenuGMM">Directorio</a></li>
							<li><a onClick={this.pickClass.bind(this, "mis-tramites")} className={this.state.tramitesClass}>Formatos y guías</a></li>
							<li><a onClick={this.pickClass.bind(this, "seguimiento-siniestros")} className={this.state.seguimientoClass} id="tramitesMenuGMM">Mis trámites</a></li>
							<li><a onClick={this.pickClass.bind(this, "mi-perfil")} className={this.state.perfilClass}>Mi perfil</a></li>
						</ul>
					</div>
				</div>
				<Notificaciones onRef={ref => (this.notificaciones = ref)} />
				<div className="show-mobile header-mobile mt-10">
					<div className="clearfix row">
						<div className="logo-header col-xs-3">
							<a onClick={ this.ir.bind(this, "home") }><img src={ require("../img/logo-gnp.svg") } style={{ "width": "90px" }} /></a>
						</div>
						<div className="perfil-options mt-20 col-xs-7">
							<ul>
								<li>
									<a onClick={this.irRutaConIframe.bind(this, "centro-atencion-gnp")} >
										<img className="centro-atencion-gnp-icon" src={require("../img/centro-atencion-gnp.svg")} title="Acceso Compartido" />
									</a>
								</li>
		                        <li><a onClick={ this.ir.bind(this, "acceso-familiar") }>
								    <img className="acceso-familiar-icon" src={ require("../img/acceso-familiar-icon.svg") } title="Acceso Compartido" />
								</a></li>
	                            <li>
	                                <a onClick={this.verNotificaciones.bind(this)}>
									<img src={require("../img/notificacion.svg")} style={{ "height": "30px", "width": "30px", "margin-left":"-7px" }} title="Notificaciones" />
	                                    { this.props.ntfBullet > 0 &&
	                                    	<sup style={{"fontSize":"10px"}}>{ this.props.ntfBullet }</sup>
	                                    }
	                                </a>
	                            </li>
								<li>
									<a onClick={ this.ir.bind(this, "beneficios") }>
										<img className="beneficios-soy-cliente-icon  beneficios-soy-cliente-icon-responsive" src={ require("../img/beneficios-soy-cliente.svg") } title="Beneficios" />
									</a>
								</li>
								<li>
									<a onClick={this.ir.bind(this, "beneficios")}>
										<img className="beneficios-soy-cliente-icon  beneficios-soy-cliente-icon-responsive " src={require("../img/beneficios-soy-cliente.svg")} title="Beneficios" />
									</a>
								</li>
								<li>
									<a className="cerrar-sesion-responsive" onClick={this.cerrarSesion.bind(this)}>
										<img  style={{ "height": "30px", "width": "25px" }} src={require("../img/log-out.svg")} title="Cerrar Sesión" />
									</a>
								</li>
							</ul>
						</div>
						<div className="bienvenida-wrap col-xs-12">
							<p><b>Hola </b><span className="orange-bold-text">{ this.props.nombre }</span></p>
							<p>Número de Cliente: <span className="blue-bold-text">{ this.props.cliente }</span></p>
							<p>Última sesión: <span>{ this.props.lastlogin }</span></p>
						</div>
					</div>
					<div className="blue-wrap">
						<div className="menu-select-mobile">
							<p onClick={this.toggleClass}>{this.state.menuTitle} <img src={ this.state.arrow[this.state.arrowIndex] }></img></p>
							<ul className={this.state.mobileClass}>
								<li onClick={this.optionGo.bind(this, "home")}>
									<a>Mis pólizas</a>
								</li>
								<li  onClick={this.optionGo.bind(this, "directorio")}>
									<a>Directorio</a>
								</li>
								<li onClick={this.optionGo.bind(this, "mis-tramites")}>
									<a>Formatos y guías</a>
								</li>
								<li onClick={this.optionGo.bind(this, "seguimiento-siniestros")}>
									<a>Mis trámites</a>
								</li>
								<li onClick={this.optionGo.bind(this, "mi-perfil")}>
									<a>Mi perfil</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Encabezado);



// WEBPACK FOOTER //
// ./src/header/encabezado.cmpt.js